import toAPIPath from './locationResolver';
import { ROUTE_ALUMNO } from './constants';

export function* uploadFile({ api, token, file, name, type = 'dietaEspecial' }) {
  const formData = new FormData();
  formData.append('archivo', file, name);
  yield api.post(toAPIPath(['storage', type, `upload?access_token=${token}`]), formData);
}

export function* saveAlumno({ api, alumno, token, isNew, alumnoId }) {
  const data = { ...alumno };
  delete data.id;
  if (isNew) {
    return yield api.post(toAPIPath([`${ROUTE_ALUMNO}?access_token=${token}`]), data);
  } else {
    yield api.put(toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]), data);
    return { id: alumnoId };
  }
}
